export const rules = {
	// Card titles
	"rules.card.rules.title": "Reglas",
	"rules.card.goals.title": "Goles",
	"rules.card.cleanSheets.title": "Portería a cero",
	"rules.card.cards.title": "Tarjetas",
	"rules.card.misc.title": "Varios",
	"rules.card.captains.title": "Capitanes y Vice Capitanes",
	"rules.card.eligibility.title": "Elegibilidad y Premios",
	"rules.card.weeklyPrizes.title": "Estructura de Premios Semanales",
	"rules.card.finalRules.title": "Distribución de Premios y Desempate",

	// Main rules content
	"rules.intro":
		'Todos los términos en mayúsculas utilizados en estas reglas (las <strong>"Reglas"</strong>) llevarán la definición atribuida a los mismos en los términos y condiciones (los <strong>"Términos y Condiciones"</strong>).',

	"rules.rule1":
		"Los participantes pueden seleccionar su mejor equipo cada semana/ronda (según sea el caso), relevante a la competencia a la que se relaciona el juego Betway Scores BW Fantasy Football, por ejemplo la Premier League inglesa, etc. La competencia Betway Scores BW Fantasy Football comenzará el 11 de marzo de 2025 y concluirá al final de la temporada de fútbol 2025/2026.",

	"rules.rule2": "Cada semana/ronda se correlaciona con las rondas de esa liga.",

	"rules.rule3":
		"Los participantes pueden seleccionar un máximo de dos (2) jugadores por equipo de liga participante para incluir en su equipo Betway Scores BW Fantasy Football cada semana/ronda.",

	"rules.rule4":
		"Los participantes necesitan seleccionar activamente su equipo cada semana/ronda, con la opción de hacer cambios o elegir mantener el mismo equipo en su lugar para la siguiente semana/ronda.",

	"rules.rule5":
		"Los puntos se asignan de la siguiente manera para cada una de las siguientes acciones realizadas por los jugadores que el Participante selecciona en su equipo Betway Scores BW Fantasy Football cada semana/ronda:",

	// Goals points
	"rules.goals.forwardGoals": "Goles de delantero",
	"rules.goals.forwardGoalsValue": "4",
	"rules.goals.midfielderGoals": "Goles de centrocampista",
	"rules.goals.midfielderGoalsValue": "5",
	"rules.goals.defenderGoals": "Goles de defensor",
	"rules.goals.defenderGoalsValue": "10",
	"rules.goals.goalkeeperGoals": "Goles de portero",
	"rules.goals.goalkeeperGoalsValue": "20",
	"rules.goals.penaltyGoals": "Goles de penalti",
	"rules.goals.penaltyGoalsValue": "3",
	"rules.goals.ownGoals": "Goles en propia puerta",
	"rules.goals.ownGoalsValue": "-5",
	"rules.goals.concededGoals": "Goles encajados",
	"rules.goals.concededGoalsValue": "-1",

	// Clean sheets points
	"rules.cleanSheets.goalkeeperCleanSheet": "Portería a cero del portero",
	"rules.cleanSheets.goalkeeperCleanSheetValue": "5",
	"rules.cleanSheets.defenderCleanSheet": "Portería a cero del defensor",
	"rules.cleanSheets.defenderCleanSheetValue": "5",
	"rules.cleanSheets.midfielderCleanSheet": "Portería a cero del centrocampista",
	"rules.cleanSheets.midfielderCleanSheetValue": "1",

	// Cards points
	"rules.cards.yellowCard": "Tarjetas amarillas",
	"rules.cards.yellowCardValue": "-2",
	"rules.cards.redCard": "Tarjetas rojas",
	"rules.cards.redCardValue": "-5",

	// Misc points
	"rules.misc.assists": "Asistencias",
	"rules.misc.assistsValue": "4",
	"rules.misc.shotsOnTarget": "Tiros a puerta",
	"rules.misc.shotsOnTargetValue": "1",
	"rules.misc.tackles": "Entradas",
	"rules.misc.tacklesValue": "2",
	"rules.misc.saves": "Paradas",
	"rules.misc.savesValue": "1",
	"rules.misc.minutesOver60": "Minutos jugados igual o superior a 60",
	"rules.misc.minutesOver60Value": "2",
	"rules.misc.minutesUnder60": "Minutos jugados inferior a 60",
	"rules.misc.minutesUnder60Value": "1",
	"rules.misc.penaltyWon": "Penalti conseguido",
	"rules.misc.penaltyWonValue": "3",
	"rules.misc.penaltiesConceded": "Penalti concedido",
	"rules.misc.penaltiesConcededValue": "-3",
	"rules.misc.penaltyMissed": "Penalti fallado",
	"rules.misc.penaltyMissedValue": "-3",
	"rules.misc.offsides": "Fueras de juego",
	"rules.misc.offsidesValue": "-1",
	"rules.misc.foulsCommitted": "Faltas cometidas",
	"rules.misc.foulsCommittedValue": "-1",

	// Captain rules
	"rules.rule6":
		'Los participantes pueden asignar un <strong>"Capitán"</strong> a su equipo que recibirá 3x puntos. El Capitán puede ser cambiado cada semana/ronda. Si el Capitán es cambiado para la siguiente semana/ronda o se mantiene en su lugar para la siguiente semana/ronda, necesita ser seleccionado activamente cada semana/ronda por el Participante.',

	"rules.rule7":
		'Los participantes pueden asignar un <strong>"Vice Capitán"</strong> a su equipo que recibirá 2x puntos. El Vice Capitán puede ser cambiado cada semana/ronda. Si el Vice Capitán es cambiado para la siguiente semana/ronda o se mantiene en su lugar para la siguiente semana/ronda, necesita ser seleccionado activamente cada semana por el Participante.',

	// Eligibility and prizes
	"rules.rule8":
		"Todos los usuarios registrados de Betway Scores y/o BW Scores son elegibles para jugar BW Fantasy Football, sin embargo solo los participantes con una cuenta Betway verificada, en el momento en que los premios van a ser otorgados, son elegibles para ganar premios. Los cambios en los resultados de las rondas según el punto 2. anterior (afectando los puntos bajo el 5. anterior) que ocurran después de otorgar los premios (por ejemplo, anulación de resultados de juegos) no serán considerados en retrospectiva.",

	"rules.rule9":
		"El Participante calificado y elegible que termine la temporada en primer lugar y tenga una Cuenta de Apuestas Betway será el ganador del Gran Premio de la temporada y ganará un viaje para dos (2) para ver jugar al Arsenal en Londres, incluyendo vuelos (si es necesario), alojamiento (si es necesario) y £500 de dinero para gastos.",

	"rules.rule10":
		"Si el ganador del Gran Premio de la temporada no puede viajar debido a no tener un pasaporte válido y/o Visa y/o cualquier otra limitación, recibirá un premio de €5,000 de saldo en efectivo, o el equivalente aproximado en moneda local en la fecha de inicio de la competencia (siendo £4,500, R100,000 o GH₵ 60,000), en su Cuenta Betway al completarse la competencia.",

	"rules.rule11":
		"El ganador del Gran Premio de la temporada puede optar por no tomar la experiencia y en su lugar aceptar un premio de €5,000 de saldo en efectivo, o el equivalente aproximado en moneda local en la fecha de inicio de la competencia (siendo £4,500, R100,000 o GH₵ 60,000), en su Cuenta Betway.",

	"rules.rule12":
		"Los Premios Semanales serán asignados a los Top 10 mejores cada semana/ronda que tengan una Cuenta de Apuestas Betway válida. Si un Top 10 no tiene una Cuenta de Apuestas Betway no se le otorgará un Premio Semanal.",

	"rules.rule13":
		"Los puestos semanales del 1 al 10 ganarán las siguientes cantidades de saldo en efectivo, dependiendo de la región, en su Cuenta Betway:",

	// Weekly prize table headers
	"rules.weeklyPrizes.position": "Posición Por Ronda",
	"rules.weeklyPrizes.eur": "Ganancias de Saldo en Efectivo (EUR)",
	"rules.weeklyPrizes.gbp": "Ganancias de Saldo en Efectivo (GBP)",
	"rules.weeklyPrizes.zar": "Ganancias de Saldo en Efectivo (ZAR)",
	"rules.weeklyPrizes.ghs": "Ganancias de Saldo en Efectivo (GHS)",

	// Weekly prize values
	"rules.weeklyPrizes.1st.eur": "€150",
	"rules.weeklyPrizes.1st.gbp": "£150",
	"rules.weeklyPrizes.1st.zar": "R3000",
	"rules.weeklyPrizes.1st.ghs": "GH₵ 2000",

	"rules.weeklyPrizes.2nd.eur": "€100",
	"rules.weeklyPrizes.2nd.gbp": "£100",
	"rules.weeklyPrizes.2nd.zar": "R2000",
	"rules.weeklyPrizes.2nd.ghs": "GH₵ 1250",

	"rules.weeklyPrizes.3rd.eur": "€75",
	"rules.weeklyPrizes.3rd.gbp": "£75",
	"rules.weeklyPrizes.3rd.zar": "R1500",
	"rules.weeklyPrizes.3rd.ghs": "GH₵ 1000",

	"rules.weeklyPrizes.4th.eur": "€50",
	"rules.weeklyPrizes.4th.gbp": "£50",
	"rules.weeklyPrizes.4th.zar": "R1000",
	"rules.weeklyPrizes.4th.ghs": "GH₵ 600",

	"rules.weeklyPrizes.5th.eur": "€40",
	"rules.weeklyPrizes.5th.gbp": "£40",
	"rules.weeklyPrizes.5th.zar": "R800",
	"rules.weeklyPrizes.5th.ghs": "GH₵ 500",

	"rules.weeklyPrizes.6th.eur": "€30",
	"rules.weeklyPrizes.6th.gbp": "£30",
	"rules.weeklyPrizes.6th.zar": "R600",
	"rules.weeklyPrizes.6th.ghs": "GH₵ 400",

	"rules.weeklyPrizes.7th.eur": "€20",
	"rules.weeklyPrizes.7th.gbp": "£20",
	"rules.weeklyPrizes.7th.zar": "R400",
	"rules.weeklyPrizes.7th.ghs": "GH₵ 250",

	"rules.weeklyPrizes.8th.eur": "€15",
	"rules.weeklyPrizes.8th.gbp": "£15",
	"rules.weeklyPrizes.8th.zar": "R300",
	"rules.weeklyPrizes.8th.ghs": "GH₵ 200",

	"rules.weeklyPrizes.9th.eur": "€10",
	"rules.weeklyPrizes.9th.gbp": "£10",
	"rules.weeklyPrizes.9th.zar": "R200",
	"rules.weeklyPrizes.9th.ghs": "GH₵ 100",

	"rules.weeklyPrizes.10th.eur": "€10",
	"rules.weeklyPrizes.10th.gbp": "£10",
	"rules.weeklyPrizes.10th.zar": "R200",
	"rules.weeklyPrizes.10th.ghs": "GH₵ 100",

	// Final rules
	"rules.rule14":
		"Los Premios Semanales serán otorgados dentro de 7 (siete) días de que los resultados de esa semana sean finalizados y el Gran Premio será otorgado dentro de 7 (siete) días de la conclusión de la competencia Betway Scores BW Fantasy Football.",

	"rules.rule15":
		"En caso de empate para los Premios Semanales, el saldo en efectivo para esa posición (y las posiciones relevantes debajo de ella que se vean afectadas por el empate) se dividirá equitativamente entre los participantes empatados.",

	"rules.rule16":
		"En caso de empate para el Gran Premio, se utilizará un mecanismo aleatorizador para seleccionar solo uno de los participantes empatados como ganador del Gran Premio.",

	"rules.temporary_notice":
		"Tenga en cuenta que los ganadores de premios durante el período del 19 de diciembre de 2025 al 2 de enero de 2026 recibirán sus premios dentro de los 7 (siete) días a partir del 6 de enero de 2026",
};
